import 'core-js/stable';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/store'
import mitt from 'mitt';
import VueGtag from 'vue-gtag'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { md3 } from 'vuetify/blueprints'

const app = createApp(App)
const emitter = mitt()

const vuetify = createVuetify({
  components,
  directives,
  blueprint: md3
})

app.config.globalProperties.emitter = emitter
app.use(router)
app.use(VueGtag, {
  config: { id: 'G-2CKQ2DDV2H' }
}, router)
app.use(store)
app.use(vuetify)
app.mount('#app')
